import { api } from "@/lib/api";

export const referralSummary = (params) =>
  api.get(`/admin/referrals/summary`, { params }).then((r) => r.data);

export const topReferrers = (params) =>
  api.get(`/admin/referrals/top-referrers`, { params }).then((r) => r.data);

export const referralCohort = (params) =>
  api.get(`/admin/referrals/cohort`, { params }).then((r) => r.data);

export const referralTimeseries = (params) =>
  api.get(`/admin/referrals/timeseries`, { params }).then((r) => r.data);
